// TODO: remove after running GOSU-0002 user testing
import { getQueryParam } from '../../routing/getQueryParam';
export const getShouldOverrideToGosu0002Variant = () => getQueryParam('gosu-0002-variant-override') === 'true';